import React from "react";

import { AdminDescriptions, Anchor, Button, Col, Row } from "components";

export const UserDetailsTab = ({ user, toggleCurrentUser }) => (
  <>
    <Row>
      <Col>
        <AdminDescriptions
          extra={
            <Button type="secondary" size="small" onClick={() => toggleCurrentUser()}>
              {user.disabled ? "Enable user" : "Disable user"}
            </Button>
          }
          items={[
            {
              span: 1.5,
              label: "Confirmed",
              children: user.confirmed ? "yes" : "no",
            },
            {
              span: 1.5,
              label: "Disabled",
              children: user.disabled ? "yes" : "no",
            },
            {
              span: 1,
              label: "Uses desktop",
              children: user.apps.desktop ? "yes" : "no",
            },
            {
              span: 1,
              label: "Uses mobile web",
              children: user.apps.mobile ? "yes" : "no",
            },
            {
              span: 1,
              label: "Uses mobile app",
              children: user.apps.app ? "yes" : "no",
            },
          ]}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <AdminDescriptions
          items={[
            {
              span: 3,
              label: "Email address",
              children: (
                <Anchor href={`mailto: ${user.email}`} mixpanelText="mailto">
                  {user.email}
                </Anchor>
              ),
            },
            {
              span: 1,
              label: "Sign up date",
              children: user.date,
            },
            {
              span: 1,
              label: "Last sign in",
              children: user.signedin,
            },
            {
              span: 1,
              label: "Last sign in",
              children: user.signedin,
            },
            {
              span: 1,
              label: "Birth year",
              children: user.birthYear ? user.birthYear : "-",
            },
            {
              span: 1,
              label: "Phone",
              children: user.phone ? user.phone : "-",
            },
            {
              span: 1,
              label: "Region",
              children: user.region ? user.region : "-",
            },
            {
              span: 1,
              label: "Newsletter consent",
              children: user.newsletter ? "yes" : "no",
            },
            {
              span: 3,
              label: "Public bio",
              children: user.bio ? user.bio : "-",
            },
          ]}
        />
      </Col>
    </Row>
  </>
);
